import styled from 'styled-components';

/** Page-level layout for the article preview route; the article anatomy itself
 *  lives with its component in components/ArticleView. */

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 2px 2px 24px;
`;

/** Centred retry action under the load-failure message. */
export const RetryWrap = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 8px;
`;
